export default __webpack_public_path__ + "static/media/243.9d485dc0.gif";